import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';
import { queryKeys } from 'src/lib/query-keys';
import { useToken } from 'src/lib/use-token';
import { _AuthApi } from 'src/services/auth';
import { authorizationAtom } from 'src/store/auth-atom';
import { userAtom } from 'src/store/user-atom';

export const useLogin = () => {
  const [, setAuth] = useAtom(authorizationAtom);
  const [, setUser] = useAtom(userAtom);
  const navigate = useNavigate();
  const { setToken } = useToken();
  return useMutation({
    mutationFn: _AuthApi.login,
    onSuccess: (data) => {
      const { token, ...user } = data;
      if (token) {
        setToken(token);
        setAuth(true);
        setUser(user);
        navigate('/home');
      }
    }
  });
};

export const useLogout = () => {
  const { removeToken } = useToken();
  const [, setAuth] = useAtom(authorizationAtom);
  const [, setUser] = useAtom(userAtom);

  return useMutation({
    mutationFn: _AuthApi.logout,
    onSuccess: () => {
      removeToken();
      setUser(null);
      setAuth(false);
    }
  });
};

export const useFetchProfile = () => {
  return useQuery({
    queryKey: [queryKeys.profile],
    queryFn: _AuthApi.getProfile
  });
};

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: _AuthApi.updateProfile,
    onSuccess: () => {
      toast.success('Updated successfully');
      queryClient.invalidateQueries({ queryKey: [queryKeys.profile] });
    }
  });
};
